import * as actionTypes from "../constants";
import { axiosApiInstance } from "../../utils";
import { setLoading } from "./user_action";
import { personTypes } from "../../models";

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

const setCreateResponse = (response) => {
  return {
    type: actionTypes.CREATE_RESPONSE,
    response,
  };
};

export const setCreateField = (field) => {
  return {
    type: actionTypes.CREATE_SET_FIELD,
    ...field,
  };
};

export const setCreateStep = (activeStep) => {
  return {
    type: actionTypes.CREATE_SET_STEP,
    activeStep,
  };
};

export const setCreateError = (error) => {
  return {
    type: actionTypes.CREATE_ERROR,
    error,
  };
};

export const reset = () => {
  return {
    type: actionTypes.RESET,
  };
};

export const createPin = ({
  personType,
  idType,
  idNumber,
  email,
  pin,
  businessName,
  firstName,
  secondName,
  firstLastName,
  secondLastName,
  userIdType,
  userIdNumber,
}) => {
  return (dispatch) => {
    const requestConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };

    const requestBody = {
      data: {
        document_type: userIdType || idType,
        document_number: userIdNumber || idNumber?.toString().trim(),
        email: email,
        pin: pin,
      },
    };

    let createPinUrl;
    dispatch(setLoading(true));
    if (personType === personTypes[0].value) {
      createPinUrl = `/api/${ENVIRONMENT}/create/user`;
      requestBody.data.first_name = firstName;
      requestBody.data.second_name = secondName || "";
      requestBody.data.surname = firstLastName;
      requestBody.data.second_surname = secondLastName || "";
    } else {
      createPinUrl = `/api/${ENVIRONMENT}/create/company`;
      requestBody.data.social_identifier = businessName;
    }

    axiosApiInstance
      .post(createPinUrl, requestBody, requestConfig)
      .then(async (response) => {
        const createResponse = response.data.data;
        dispatch(setCreateResponse(createResponse));
      })
      .catch((error) => {
        dispatch(reset());
        dispatch(setCreateError(true));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};
